module.exports = __webpack_public_path__ + "img/21.f57c4f91.jpg";